module.exports = __webpack_public_path__ + "static/media/image7.0154e981.png";